import { render } from "./Invoice_check.vue?vue&type=template&id=0cb65594"
import script from "./Invoice_check.vue?vue&type=script&lang=js"
export * from "./Invoice_check.vue?vue&type=script&lang=js"
script.render = render

export default script